<template>
  <b-card
    no-body
    class="d-flex justify-content-between align-items-right hero"
  >
    <b-row>
      <b-col
        cols="8"
        class="text-sm-left mb-0"
      >
        <span
          class="mb-0 font-weight-bolder mian"
          style="font-size:20px;"
        >Power Meter
        </span>
      </b-col>
      <b-col
        cols="4"
        class="text-sm-right mt-0"
      >
        <b-button
          id="toggle-btn"
          v-b-modal="'modalPowerMeter'"
          variant="primary"
          style="font-size: 14px;"
        >
          View<feather-icon
            size="14"
            icon="ChevronsRightIcon"
          />
        </b-button>
      </b-col>
    </b-row>
    <ModalPowerMeter />
    <app-echart-power-meter
      :option-data="option"
    />
  </b-card>
</template>

<script>
import {
  BCard, BCol, BRow, BButton,
  // BCardBody,
} from 'bootstrap-vue'
import axios from '@axios'
import AppEchartPowerMeter from '@/@core/components/charts/echart/AppEchartPowerMeter.vue'
import ModalPowerMeter from '@/views/StatisModal/ModalPowerMeter.vue'

export default {
  components: {
    BCard,
    BCol,
    BRow,
    BButton,
    AppEchartPowerMeter,
    ModalPowerMeter,
  },

  data() {
    return {
      statisticTitle: '',
      xAxis: [],
      option: {
        yAxis: [
          {
            type: 'category',
            data: [],
            axisLabel: {
              hideOverlap: true,
              show: true,
              fontSize: 12,
              color: '#fff',
            },
          },
        ],
        xAxis: [
          {
            axisLabel: {
              hideOverlap: true,
              show: true,
              fontSize: 12,
              color: '#fff',
            },
            type: 'value',
            splitLine: { show: false },
          },
        ],
        grid: {
          show: false,
          containLabel: false,
          borderWidth: '1px',
          left: '160px',
          right: '15px',
          bottom: '25px',
          top: '25px',
        },
        series: [
          {
            name: 'Vote',
            type: 'bar',
            stack: 'advertising',
            data: [],
            barMaxWidth: '20%',
            barMinWidth: '10px',
            itemStyle: {
              color: '#FF9E00',
            },
          },
          {
            name: 'Amp',
            type: 'bar',
            stack: 'advertising',
            data: [],
            barMaxWidth: '20%',
            barMinWidth: '10px',
            itemStyle: {
              color: '#0054FF',
            },
          },
        ],
      },
      items: [],
    }
  },
  mounted() {
    this.getPowerMeter()
  },
  methods: {
    getPowerMeter() {
      axios
        .get('/get_powerMeter')
        .then(response => {
          this.xAxis = []
          this.xAxis = response.data
          this.xAxis.forEach(value => {
            this.option.yAxis[0].data.push(value.devbuilding)
            this.option.series[0].data.push(value.volt)
            this.option.series[1].data.push(value.amp)
          })
        })
        .catch(error => {
          console.log(error)
        })
    },
  },
}
</script>
<style scoped>

.hero::before {
      content: "";
      background-image: url(~@/assets/images/icons/gate.jpg);
      position: absolute;
      background-size: cover;
      top: 0px;
      right: 0px;
      bottom: 0px;
      left: 0px;
      opacity: 0.4;
      border-radius: 20px;
  }

.mian {
  position: relative;
  color: #ffffff;
  font-size: 14rem;
  line-height: 1.8;
  text-align: center;
  padding: 5px;text-align: left; font-size:14px; text-decoration: underline
}
.p {
  position: relative;
  color: #ffffff;
  font-size: 14rem;
  line-height: 0.9;
  padding: 5px;text-align: left; font-size:14px;
}
</style>
